import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import React from "react";
import SearchBoard from "./SearchBoard";
import CustomMenu from "../../../../components/Menu";
import SelectAllMenuItem from "./SelectAllBoardMenuItem";
import "../../myTask.scss";
import TeamAccordion from "./TeamAccordion";
import UnassignedUsersAccordion from "./UnassignedUsersAccordion";
import TeamButton from "./TeamButton";
import { useResponsive } from "../../../../hooks/useResponsive";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useTeamFilterState } from "../../hooks/useTeamFilterState";

const Team = React.memo(
  function Team({ team }) {
    const isMobile = useResponsive("down", "md");
    const {
      anchorEl,
      open,
      searchQuery,
      openUnassigned,
      expandedPanel,
      selectedUsers,
      unAssignedTeam,
      allUser,
      visibleTeams,
      setAnchorEl,
      setSearchQuery,
      setUnassigned,
      handleExpandAccordianChange,
      setTeam,
      handleClose,
      selectAll,
    } = useTeamFilterState(team);

    return (
      <>
        {isMobile ? (
          <Accordion className="filter-accordion">
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1-content"
              id="panel1-header">
              <Typography component="span">
                By Users{" "}
                <span className="filter-count">
                  {selectedUsers.length === 0 ? "" : selectedUsers.length}
                </span>
              </Typography>
            </AccordionSummary>
            <AccordionDetails sx={{ padding: "0px 12px 12px" }}>
              <SearchBoard
                onSearch={(val) => setSearchQuery(val)}
                searchQuery={searchQuery}
              />
              <div className="filter-accordion-content">
                {!searchQuery && (
                <SelectAllMenuItem
                  selectAll={selectAll}
                  className={"select-all-menu-item"}
                  label={"Select All Users"}
                  checked={selectedUsers.length === allUser.length}
                />
              )}
                {visibleTeams.map((team) =>
                  team ? (
                    <TeamAccordion
                      key={`team-${team.team_id}`}
                      team={team}
                      user={selectedUsers}
                      expandedPanel={expandedPanel}
                      handleExpandAccordianChange={handleExpandAccordianChange}
                      setTeam={setTeam}
                      filteredItems={allUser}
                      searchQuery={searchQuery}
                    />
                  ) : (
                    ""
                  )
                )}
                {unAssignedTeam.length > 0 && (
                  <UnassignedUsersAccordion
                    unAssignedTeam={unAssignedTeam}
                    setUnassigned={setUnassigned}
                    user={selectedUsers}
                    searchQuery={searchQuery}
                    openUnassigned={openUnassigned}
                  />
                )}
              </div>
            </AccordionDetails>
          </Accordion>
        ) : (
          <>
            <TeamButton user={selectedUsers} setAnchorEl={setAnchorEl} />
            <CustomMenu
              anchorEl={anchorEl}
              open={open}
              onClose={handleClose}
              isApplyCustomMenuCss={false}
              className="custom-menu-box-shadow-none">
              <Box className="search-box">
                <SearchBoard
                  onSearch={(val) => setSearchQuery(val)}
                  searchQuery={searchQuery}
                />
              </Box>
              {!searchQuery && (
                <SelectAllMenuItem
                  selectAll={selectAll}
                  className={"select-all-menu-item"}
                  label={"Select All Users"}
                  checked={selectedUsers.length === allUser.length}
                />
              )}
              {visibleTeams.map((team) =>
                team ? (
                  <TeamAccordion
                    key={`team-${team.team_id}`}
                    team={team}
                    user={selectedUsers}
                    expandedPanel={expandedPanel}
                    handleExpandAccordianChange={handleExpandAccordianChange}
                    setTeam={setTeam}
                    filteredItems={allUser}
                    searchQuery={searchQuery}
                  />
                ) : (
                  ""
                )
              )}
              {unAssignedTeam.length > 0 && (
                <UnassignedUsersAccordion
                  unAssignedTeam={unAssignedTeam}
                  setUnassigned={setUnassigned}
                  user={selectedUsers}
                  searchQuery={searchQuery}
                  openUnassigned={openUnassigned}
                />
              )}
            </CustomMenu>
          </>
        )}
      </>
    );
  },
  (prevProps, nextProps) => {
    // For React.memo, return true to prevent re-render, false to allow re-render
    // We only need to check if team data has changed since user data is now from Redux

    // Check if team data has changed
    const teamDataChanged =
      prevProps.team?.data?.data?.responseData?.length !==
        nextProps.team?.data?.data?.responseData?.length ||
      JSON.stringify(prevProps.team?.data?.data?.responseData) !==
        JSON.stringify(nextProps.team?.data?.data?.responseData);

    // Return false to trigger re-render when team data has changed
    return !teamDataChanged;
  }
);

export default Team;
